import '../styles/ModalCambios.css';

export default function ModalCambios({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-cambios">
        <h3>¡¡Novedades de la versión!!</h3>

        <ul className="lista-cambios">
          <li>ALBARANES LABORATORIO:
            <ul>
              <li className="lista-cambios 2">Nuevo punto de menú "Laboratorios" tanto en la pantalla de inicio como en en la barra de navegación</li>
              <li className="lista-cambios 2">Consiste en una tabla donde añadir los albaranes de los laboratorios de trabajos de los profesionales</li>
            </ul>
          </li>          
          <li>REECALLS:
            <ul>
              <li className="lista-cambios 2">Se han corregido errores en los filtros por fecha y por estado.</li>
              <li className="lista-cambios 2">Se ha mejorado visualmente el formulario de crear recordatorio</li>
            </ul>
          </li>
          <li>IMAGENES:
            <ul>
              <li className="lista-cambios 2">Ya se pueden subir imagenes de un tamaño superior a 3mb e inferior a 10mb</li>
              <li className="lista-cambios 2">Con esta solución se deberían poder subir imagenes desde la tablet</li>
            </ul>
          </li>
        </ul>

        <h4>Recordatorios</h4>
        <ul className="lista-recordatorios">
          <li>Ya funciona el odontograma, solamente al entrar un nuevo tratamiento, comprobar que no existe otro llamdo igual</li>
          <li>Cualquier duda o error, contactar con Raúl.</li>
        </ul>

        <div className="modal-acciones">
          <button onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
